<app-modal-dialog
    [bodyTemplate]="bodyTemplate"
    [showCloseButton]="false"
    [footerTemplate]="footerTemplate">
    <ng-template #bodyTemplate>
        <div class="container-fluid">
            <h5 class="dialog">
                <mat-icon
                    class="icon-color-primary me-2"
                    fontSet="material-symbols-outlined"
                    >{{ data.icon }}</mat-icon
                >
                {{ data.headline }}
            </h5>
            <p class="font-16 tw-mt-5">
                {{ data.msg }}
            </p>

            <!-- Only show unchecked articles section if deliveryNotes exist and there are unchecked articles -->
            @if (data.deliveryNotes && hasUncheckedArticles) {
                <div>
                    <div class="tw-mt-4">
                        <mat-accordion>
                            @for (dn of uncheckedArticles; track dn) {
                                <mat-expansion-panel class="tw-mt-2">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            {{
                                                'INCOMING-GOODS.DISCREPANCIES.NOTE'
                                                    | translate
                                            }}: {{ dn.deliveryNoteNumber }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ul class="tw-mt-1 tw-list-disc tw-pl-5">
                                        @for (
                                            article of dn.articles;
                                            track article
                                        ) {
                                            <li
                                                class="tw-mt-1 tw-flex tw-items-center tw-gap-1">
                                                {{ article.description }} ({{
                                                    article.articleNumber
                                                }})
                                                <mat-icon
                                                    fontSet="material-symbols-outlined"
                                                    class="tw-cursor-pointer tw-text-sm tw-opacity-60 hover:tw-opacity-100"
                                                    [matTooltip]="
                                                        'OUTGOING-GOODS.NOTIFICATION-VIEW.COPY'
                                                            | translate
                                                    "
                                                    (click)="
                                                        showKeyCopiedToast()
                                                    "
                                                    [cdkCopyToClipboard]="
                                                        article.articleNumber
                                                    "
                                                    >file_copy</mat-icon
                                                >
                                            </li>
                                        }
                                    </ul>
                                </mat-expansion-panel>
                            }
                        </mat-accordion>
                    </div>
                </div>
            }
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        @if (!data.hideBackButton) {
            <button
                tabindex="-1"
                type="button"
                mat-stroked-button
                (click)="closeWithResult('selfClose')">
                {{ 'CONFIRMATION-DIALOG.BUTTON-BACK' | translate }}
            </button>
        }
        <button
            id="button-bottom-no"
            tabindex="1"
            type="button"
            mat-flat-button
            color="primary"
            (click)="closeWithResult('save')">
            Okay
        </button>
    </ng-template>
</app-modal-dialog>
